import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/yerkir-next/src/app/[locale]/components/ClientNotFound.tsx");
